// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/download-to-excel/download-to-excel.scss';
import './index.scss';
import React, {PropTypes} from 'react';
import DownloadToExcelForPanel from '../../../../shared/components/download-to-excel-for-panel';
import {FormattedMessage} from 'react-intl';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {exportToExcel} from '../../../../shared/services/export-to-excel';

const ClaimLineItemPanel = (props, context) => {

    const downloadToExcelEl = (
        <DownloadToExcelForPanel onDownload={() => exportToExcel(`/api/claim-line-items/${props.claimNumber}?export=EXCEL&language=${context.user.getLocale()}&tabm=${props.tabm}`)}/>);

    return (
        <section className='claim-line-item-panel'>
            <header className='claim-line-item-header'>
                <FormattedMessage id='LINE_ITEMS_EXPORT'/>
                {downloadToExcelEl}
            </header>
        </section>
    );

};

ClaimLineItemPanel.displayName = 'ClaimLineItemPanel';
ClaimLineItemPanel.propTypes = {
    claimNumber: PropTypes.string.isRequired,
    tabm: PropTypes.bool.isRequired
};
ClaimLineItemPanel.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimLineItemPanel;



// WEBPACK FOOTER //
// ./src/claim/spa/components/claim-line-item-panel/index.js